<template>
    <div class='tw-w-full tw-p-4 tw-flex tw-flex-col tw-gap-3' style="min-width:min(40rem, calc(100vw - 4rem));">
        <div class="tw-flex tw-flex-col">
            <p class='tw-font-bold tw-text-lg'>{{profesional?.nombre}}</p>
            <p class='tw-font-semibold tw-text-sm'>{{especialidad?.nombre}}</p>
        </div>
        <hr class='tw-w-full' />
        <div>
            <div v-if='Array.isArray(itemsProcesados)' class="tw-min-w-full">
                <DataTable :value="itemsProcesados" paginator :rows='5' class='tw-min-w-full'>
                    <Column field="codigo" header="Codigo"></Column>
                    <Column field="descripcion" header="Descripcion"></Column>
                    <Column field="cantidad" header="Cantidad"></Column>
                </DataTable>
            </div>
            <div v-else class="tw-text-left">
                <p class='tw-font-medium'>Rp.:</p>
                <p v-for='(item, index) in itemsProcesados.split("\n")' :key='index' class='tw-pl-4'>
                    {{item}}
                </p>
            </div>
        </div>
    </div>
</template>
<script lang='ts'>
import {computed, defineComponent, onMounted, ref } from 'vue'
import axios from '@/plugins/axios';

export default defineComponent({
    name:'RecetaInfo',
    props:{
        id:{
            type:String,
            required:true
        },
    },
    setup(props,{emit}){
        const datos = ref<any>(null)
        const obtenerDatos = async () => {
            try {
                const { data } = await axios.get(`/historia-clinica-get-registros/${props.id}`)
                datos.value = data
            } catch (error) {
                console.log(error);
            }
        }

        const profesional = computed(() => {
            return datos.value?.medico || null
        })

        const especialidad = computed(() => {
            return datos.value?.especialidad || null
        })
        
        const items = computed(() => datos.value?.datos?.items || datos.value?.datos?.itemsSolicitados  || datos.value?.datos?.rp || [])
        const itemsProcesados = computed(() => {
            if(!Array.isArray(items.value)) return items.value
            if(items.value.length === 0) return []
            return items.value.map((item) => {
                if(item.cantidad && (item.practica || item.medicamento || item.producto)){
                    return {
                        cantidad: item.cantidad,
                        descripcion: item.producto?.producto,
                        ...(item.practica || item.medicamento || item.producto),
                        
                    }
                }
                return item
            })
        })
        const datosRc = computed(() => datos.value?.datos)

        onMounted(() => {
            obtenerDatos()
        })
        return{
            datos,
            datosRc,
            items,
            itemsProcesados,
            profesional,
            especialidad,
        }
    }
})
</script>
<style lang='scss'></style>